import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { Delete, Videocam, ArrowBack } from '@mui/icons-material';
import backForward from 'packages/novous_web/src/assets/icons/Fast Backward.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import MapPreview from '../../Home/components/MapPreview';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import edit from 'packages/novous_web/src/assets/icons/edit.svg';
import LiveFeedModal from '../../Reports/components/LiveFeed';
import { useEffect, useMemo, useRef, useState } from 'react';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import AlertToast from '../../../../common/components/Alert';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import RequestedVideoModal from 'packages/novous_web/src/common/components/RequestedVideoModal';
import PlaybackPlayerModal from '../../Trips/componenets/PlayackPLayerModal';
import TripHistoryTable from './components/TripHistoryDataTable';
import RequestVehicleHistoryModal from 'packages/novous_web/src/common/components/RequestHistoryModal';
import TripSummary from './components/RunningHistory';
import reset from '../../../../assets/icons/Reset.svg';
import dayjs from 'dayjs';
import Loader from 'packages/novous_web/src/common/components/Loader';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';
import DateRangeSelectorButton from '../components/DateRangeSelectorButton';
import axisInstance from 'packages/novous_web/src/api/apiClient';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ShareLinkModalBox from 'packages/novous_web/src/pages/Dashboard/Directories/components/ShareLinkModalBox';
import editIcon from 'packages/novous_web/src/assets/icons/edit.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
interface Vehicle {
  vehicleName: string;
  vehicleRegistrationNo: string;
  groupName: string;
}
const VehicleDetails = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };
  const [isShareLikOpen, setIsShareLinkOpen] = useState(false);

  const [shareLink, setShareLink] = useState<string>('');
  const handleShareLink = () => {
    if (!selectedVehicle) return;

    const currentTime = new Date().toISOString();
    const link = `${window.location.origin}/vehicle/track/${
      selectedVehicle.vehicleRegistrationNo
    }?time=${encodeURIComponent(currentTime)}&lat=${selectedVehicle.lastLatitude}&lng=${
      selectedVehicle.lastLongitude
    }`;

    // navigator.clipboard.writeText(link)
    //     .then(() => {
    //         console.info('Link copied to clipboard:', link);
    //     })
    //     .catch(err => {
    //         console.error('Failed to copy link: ', err);
    //     });

    // window.open(link, '_blank');
    setShareLink(link);
    setIsShareLinkOpen(true);
  };
  const handelShareLinkModalClose = () => {
    setIsShareLinkOpen(false);
  };

  const theme = useTheme();
  const location = useLocation();
  const initialVehicleState = location.state || {};
  const [initialVehicleData, setInitialVehicleData] = useState(initialVehicleState || location.state);
  console.log(initialVehicleData, 'initialVehicleData');
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({ isOpen: false, vehicleId: '' });
  const [isRequestPlayBack, setIsRequestPlayBack] = useState({ isOpen: false, vehicleId: '' });
  const [isRequestHistory, setIsRequestHistory] = useState({ isOpen: false, vehicleId: '' });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // State for delete modal
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [vehicleVideoPlayer, setVehicleVideoPlayer] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
  const loadingFootageRef = useRef(false);
  const [requestData, setRequestedData] = useState<any>();
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const [showHistory, setShowHistory] = useState(false);
  const [historyDate, setHistoryDate] = useState<any>();
  const today = dayjs().format('YYYY-MM-DD');
  const [activeTab, setActiveTab] = useState<'generalDetails' | 'tripHistory' | 'runningHistory'>(
    'generalDetails',
  );
  // State for Filter Model
  const pageLocation = useLocation();
  const [defaultDateRange, setDefaultDateRange] = useState<string>('Today');
  const params = new URLSearchParams(pageLocation.search);
  const redirectedStatus: any = params.get('status');
  const [searchQuery, setSearchQuery] = useState(redirectedStatus || '');
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const debouncedSearchQuery = useDebounce(searchQuery, 1000);
  const [filterData, setFilterData] = useState<{ data: any; isfiltered: boolean }>({
    data: {},
    isfiltered: false,
  });
  const [selectedVehicle, setSelectedVehicle] = useState(initialVehicleData);
  const handleFilterClose = () => setIsFilterModelOpen(false);
  const handleFilterOpen = () => setIsFilterModelOpen(true);
  const [vehicleList, setVehicleList] = useState<Vehicle[]>([]);
  const [matchStatus, setMatchStatus] = useState<null | 'found' | 'not-found'>(null);
  //End of States for Filter Modal
  console.log(location.state, 'locationState');
  const {
    data: allVehicleData,
    error: routesError,
    loading: routesLoading,
    fetchData: fetchVehicleData,
  } = useAxios<any>(`${API_ENDPOINTS.dashboard.FLEET_ALL_STATUS}`, 'POST');
  useEffect(() => {
    if (allVehicleData?.data) {
      const vehicleListData: Vehicle[] = allVehicleData?.data?.map((vehicle: any) => ({
        vehicleName: vehicle.vehicleName,
        driverName: vehicle.driverName,
        gpsSpeed: vehicle.gpsSpeed,
        vehicleRegistrationNo: vehicle.vehicleRegistrationNo,
        vehicleType: vehicle.vehicleType,
        lastLocationAddress: vehicle.lastLocationAddress,
        vehicleState: vehicle.vehicleState,
        lastLatitude: vehicle.lastLatitude,
        lastLongitude: vehicle.lastLongitude,
        chassisNo: vehicle.chassisNo,
        deviceType: vehicle.deviceType,
        modelYear: vehicle.modelYear,
        model: vehicle.model,
        vehicleManufacturer: vehicle.vehicleManufacturer,
        groupName: vehicle.groupName,
        lastUpdateTime: vehicle.lastUpdateTime,
        deviceId: vehicle.deviceId,
        tripStatus: vehicle.tripStatus,
        totalKmToday: vehicle.totalKmToday,
        tripName: vehicle.tripName,
        tripId: vehicle.tripId,
      }));
      setVehicleList(vehicleListData);
    }
  }, [allVehicleData]);
  useEffect(() => {
    if (activeTab === 'runningHistory' && (!historyDate || !historyDate.startDate || !historyDate.endDate)) {
      const today = dayjs().format('YYYY-MM-DD');
      setHistoryDate({
        startDate: today,
        endDate: today,
        startTime: '00:00:00',
        endTime: '23:59:59',
      });
      setShowHistory(true); // Optionally reset showHistory
    }
  }, [activeTab]);

  const handleFilterSave = (data: any) => {
    console.log(data, 'databyfilter');
    setFilterData({ data: data, isfiltered: true });

    const selectedVehicleData = vehicleList.find((v) => v.vehicleRegistrationNo === data.vehicle);
    console.log(selectedVehicleData, 'selectedVehicleData');

    setSelectedVehicle(vehicleList.find((v) => v.vehicleRegistrationNo === data.vehicle));
    if (selectedVehicle) {
      setInitialVehicleData(selectedVehicleData);
    } else {
      setInitialVehicleData(initialVehicleData);
    }
    setSearchQuery('');
  };
  // const {
  //     data: vehicleData,
  //     error: vehicleError,
  //     loading: vehicleLoading,
  //     fetchData: fetchVehicleData,
  // } = useAxios<any>(`${API_ENDPOINTS.dashboard.VEHICLE}`, "POST");
  // useEffect(() => {

  //     if (user?.customer_id) {
  //         fetchVehicleData({ fleetId: user?.customer_id });
  //     }
  // }, [user?.customer_id])
  console.log(vehicleList, 'vehicleList');
  // useEffect(() => {
  //     console.log(debouncedSearchQuery, 'debouncedSearchQueryxyz');

  //     let isFound = vehicleList.find(v => v.vehicleRegistrationNo === debouncedSearchQuery);
  //     console.log(isFound, 'isFound');
  //     if (isFound?.vehicleRegistrationNo) {
  //         setInitialVehicleData(isFound);
  //     }

  // }, [debouncedSearchQuery]);
  useEffect(() => {
    if (debouncedSearchQuery.trim() === '') {
      setMatchStatus(null); // Reset status on empty input
      return;
    }

    //const isFound = vehicleList.find(v => v.vehicleRegistrationNo === debouncedSearchQuery);
    const isFound = vehicleList.find(
      (v) => (v.vehicleRegistrationNo || '').toLowerCase() === debouncedSearchQuery.toLowerCase(),
    );

    console.log(isFound, 'isFound');

    if (isFound?.vehicleRegistrationNo) {
      setInitialVehicleData(isFound);
      setMatchStatus('found');
    } else {
      setMatchStatus('not-found');
    }
  }, [debouncedSearchQuery]);
  useEffect(() => {
    if (matchStatus !== null) {
      const timer = setTimeout(() => setMatchStatus(null), 2000);
      return () => clearTimeout(timer);
    }
  }, [matchStatus]);

  // Fetch vehicle data based on search query
  const {
    data: downloadVehicleData,
    error: downloadVehicleError,
    loading: downloadVehicleLoading,
    fetchData: fetchDownloadVehicleData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.VEHICLE_DOWNLOAD}`, 'POST', 'blob');
  const { data: tripOverviewData, fetchData: fetchTripOverviewData } = useAxios<{ data: any }>(
    `${API_ENDPOINTS.trip.TRIP_OVERVIEW}`,
    'POST',
  );
  const {
    data: requestVideoData,
    error: requestVideoError,
    loading: requestVideoLoading,
    fetchData: fetchRequestVideoData,
  } = useAxios<{ data: any; message: string }>(`${API_ENDPOINTS.dashboard.CREATE_VOD}`, 'POST');

  const {
    data: footageVideoData,
    error: footageVideoError,
    loading: footageVideoLoading,
    fetchData: fetchFootageVideoData,
  } = useAxios<{ data: any; message: string }>(`${API_ENDPOINTS.sdCard.GET_FOOTAGE}`, 'POST');

  useEffect(() => {
    if (footageVideoError) {
      console.log(footageVideoError, 'footageVideoError');

      setToast({ open: true, message: footageVideoError || 'Failed to fetch video', type: 'error' });
      // setVehicleVideoPlayer(false);
    }
  }, [footageVideoError]);

  const {
    data: vehicleDeleteData,
    error: vehicleDeleteError,
    loading: vehicleDeleteLoading,
    fetchData: fetchvehicleDeleteData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.DELETE_VEHICLE}`, 'POST');

  const {
    data: requestedVideoData,
    error: requestedVideoError,
    loading: requestedVideoLoading,
    fetchData: fetchRequestedVideoData,
  } = useAxios<{ data: any }>(`${API_ENDPOINTS.dashboard.FETCH_VOD}`, 'POST');

  const {
    data: cameraData,
    error: cameraError,
    loading: cameraLoading,
    fetchData: getCameraData,
  } = useAxios<any>(
    `${API_ENDPOINTS.directories.GET_CAMERA}${initialVehicleData.vehicleRegistrationNo}`,
    'GET',
  );

  const cameraArr: string[] = useMemo(() => {
    if (cameraData?.data) {
      return Object.keys(cameraData.data);
    } else {
      return [];
    }
  }, [cameraData]);
  useEffect(() => {
    if (cameraError) {
      setToast({ open: true, message: 'Failed to fetch Camera', type: 'error' });
    } else if (requestVideoError) {
      setToast({ open: true, message: 'Failed to request Video', type: 'error' });
    }
  }, [cameraError, requestVideoError]);

  useEffect(() => {
    console.log(footageVideoData, 'footageVideoData');

    let timeoutId: NodeJS.Timeout;

    if (Object.keys(footageVideoData?.data || {}).length > 0) {
      console.log('Footage data received:', footageVideoData?.data);
      if (footageVideoData?.data?.message === 'Device is currently offline') {
        loadingFootageRef.current = false;
        setToast({ open: true, message: 'Device is currently offline', type: 'error' });
        return;
      } else {
        loadingFootageRef.current = false;
      }
      setVehicleVideoPlayer(true);
    } else if (footageVideoData?.data && Object.keys(footageVideoData.data).length === 0) {
      setVehicleVideoPlayer(false);
      setToast({ open: true, message: 'Footage not available', type: 'error' });
    } else if (footageVideoData?.data) {
      loadingFootageRef.current = true;
      // Retry after 5 sec
      timeoutId = setTimeout(() => {
        fetchFootageVideoData({
          vehicleName: initialVehicleData.vehicleName || '',
          cameraId: cameraData.data[requestData.cameraType][1],
          deviceId: initialVehicleData.deviceId,
          ...requestData,
        });
      }, 5000);
    }

    // Clean up timeout on unmount or effect rerun
    return () => clearTimeout(timeoutId);
  }, [footageVideoData]);

  const handleVideoPlayerRefresh = () => {
    fetchFootageVideoData({
      vehicleName: initialVehicleData.vehicleName || '',
      cameraId: cameraData.data[requestData.cameraType][1],
      deviceId: initialVehicleData.deviceId,
      ...requestData,
    });
  };

  const handleLiveFeedOpen = (vehicleId: string) => {
    setIsLiveFeedOpen({ isOpen: true, vehicleId });
  };

  const handleRequestPlayBackOpen = (vehicleId: string) => {
    if (initialVehicleData.vehicleState === 'STOP') {
      setToast({
        open: true,
        message: 'Video is currently stopped. Please try another time.',
        type: 'error',
      });
      return;
    }
    getCameraData();
    setIsRequestPlayBack({ isOpen: true, vehicleId });
  };

  const handleRequestHistoryPlayBackOpen = (vehicleId: string) => {
    setIsRequestHistory({ isOpen: true, vehicleId });
  };

  const handleLiveFeedClose = () => {
    setIsLiveFeedOpen({ isOpen: false, vehicleId: '' });
  };

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true); // Open delete confirmation modal
  };

  const handleRequestedModalClose = () => {
    setIsRequestPlayBack({ isOpen: false, vehicleId: '' });
  };

  const handleRequestedHistoryModalClose = () => {
    setIsRequestHistory({ isOpen: false, vehicleId: '' });
  };

  const handleDeleteConfirm = () => {
    fetchvehicleDeleteData(initialVehicleData); // Call delete endpoint
    setIsDeleteModalOpen(false); // Close modal
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false); // Close modal without deleting
  };

  const handleRequested = (data: any) => {
    setRequestedData(data);
    loadingFootageRef.current = true;
    fetchFootageVideoData({
      vehicleName: initialVehicleData.vehicleName || '',
      cameraId: cameraData.data[data.cameraType][1],
      deviceId: initialVehicleData.deviceId,
      ...data,
    });
  };

  const handleHistoryRequested = (data: any) => {
    if (data.startDate && data.endDate && data.startTime && data.endTime) {
      setHistoryDate(data);
      setShowHistory(true);
    }
  };

  useEffect(() => {
    if (vehicleDeleteData?.data === 'success') {
      setToast({ open: true, message: 'Vehicle Deleted Successfully.', type: 'success' });
      setTimeout(() => {
        navigate(-1);
      }, 3000);
    } else if (vehicleDeleteError) {
      setToast({ open: true, message: 'Error occurred while deleting vehicle.', type: 'error' });
    }
  }, [vehicleDeleteData, vehicleDeleteError]);
  const handleDownload = async () => {
    fetchDownloadVehicleData({
      fleetId: user?.customer_id,
      fileType: selectedFormat,
      vehicleId: initialVehicleData?.vehicleRegistrationNo,
    });
  };
  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat(event.target.value);
  };
  useEffect(() => {
    if (downloadVehicleData) {
      try {
        if (downloadVehicleData instanceof Blob) {
          const url = window.URL.createObjectURL(downloadVehicleData);
          const a = document.createElement('a');
          a.href = url;
          let extension = selectedFormat.toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx'; // Use xlsx for Excel format
          }

          const fileName = `vehicles_data.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false); // Close the modal
      }
    }
  }, [downloadVehicleData]);

  const handleDownloadModalClose = () => {
    setIsDownloadModalOpen(false);
  };

  const handleVideoPlayerClose = () => {
    setVehicleVideoPlayer(false);
  };
  const handleRegenerateHistory = (vehicleId: any) => {
    setIsRequestHistory({ isOpen: true, vehicleId });
  };
  function formatCustomTimestamp(timestamp: string): string {
    // Parse using the custom format
    const parsed = dayjs(timestamp, 'YYYY-MM-DD:HH:mm:ss');
    if (!parsed.isValid()) return 'NA';

    // Format to desired output: '13th May 21:51 PM'
    return parsed.format('Do MMM HH:mm A');
  }
  // const fetchAddress = async (lat: any, lng: any): Promise<string> => {
  //     const googleApiKey = process.env.NX_PUBLIC_MAP_API_KEY;
  //     const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleApiKey}`;
  //     try {
  //         const response = await fetch(url);
  //         const data = await response.json();
  //         if (data.status === "OK" && data.results && data.results.length > 0) {
  //             return data.results[0].formatted_address;
  //         }
  //     } catch (error) {
  //         console.error("Error fetching address:", error);
  //     }
  //     return "NA";
  // };
  const fetchAddress = async (lat: any, lon: any) => {
    setAddress('Loading...');
    if (lat === '0' || lon === '0' || lat === '' || lon === '') {
      setAddress('NA');
      return;
    }

    try {
      const response = await axisInstance({
        url: API_ENDPOINTS.google.GOOGLE_ADDRESS,
        method: 'POST',
        data: {
          latitude: parseFloat(lat),
          longitude: parseFloat(lon),
        },
        responseType: 'json',
      });

      const result = response.data;

      if (result?.status === 200 && result?.data) {
        setAddress(result.data);
      } else {
        setAddress('NA');
      }
    } catch (err) {
      console.error('Error fetching address:', err);

      setAddress('NA');
    }
  };
  const [address, setAddress] = useState<string>('NA');
  useEffect(() => {
    fetchAddress(initialVehicleData?.lastLatitude, initialVehicleData?.lastLongitude);
  }, [initialVehicleData?.lastLatitude, initialVehicleData?.lastLongitude]);

  // useEffect(() => {
  //     if (filterData?.isfiltered) {
  //         fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null, vehicleGroup: filterData?.data?.vehicleGroup, vehicleType: filterData?.data?.vehicleType, vehicleStatus: filterData?.data?.group });
  //     }
  //     else {
  //         fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
  //     }
  // }, [filterData])
  useEffect(() => {
    if (!user?.customer_id) return;
    fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
  }, [user?.customer_id]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (initialVehicleData?.vehicleState === 'IDLE' || initialVehicleData?.vehicleState === 'RUNNING') {
      intervalId = setInterval(() => {
        fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
      }, 12000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [initialVehicleData?.vehicleState, user?.customer_id]);

  useEffect(() => {
    if (allVehicleData?.data && initialVehicleData?.vehicleRegistrationNo) {
      const updatedVehicle = allVehicleData.data.find(
        (v: any) => v.vehicleRegistrationNo === initialVehicleData.vehicleRegistrationNo,
      );

      if (updatedVehicle) {
        setInitialVehicleData((prevData: any) => ({
          ...prevData,
          lastLatitude: updatedVehicle.lastLatitude,
          lastLongitude: updatedVehicle.lastLongitude,
          lastUpdateTime: updatedVehicle.lastUpdateTime,
          gpsSpeed: updatedVehicle.gpsSpeed,
          vehicleState: updatedVehicle.vehicleState,
          totalKmToday: updatedVehicle.totalKmToday,
        }));
      }
    }
  }, [allVehicleData?.data]);

  console.log('filterData', filterData, initialVehicleData, selectedVehicle);

  const handleDateRangeChange = (
    from: string,
    to: string,
    fromTime?: string,
    toTime?: string,
    label?: string,
  ) => {
    console.log('Selected Range:', from, to);
    if (from && to) {
      // If fromTime is not provided, default to '00:00:00'
      fromTime = fromTime || '00:00:00';
      // If toTime is not provided, default to '23:59:59'
      toTime = toTime || '23:59:59';

      setDefaultDateRange(label || 'Custom Range');
      const data = { startDate: from, endDate: to, startTime: fromTime, endTime: toTime };
      setHistoryDate(data);
      setShowHistory(true);
    }
    console.log('History Date:', historyDate);
    // You can use these dates to fetch filtered data
  };

  return (
    <>
      {footageVideoLoading && <Loader />}
      <div className="flex flex-col p-6">
        <div className="flex flex-col gap-4">
          <div>
            <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
              Back
            </Button>
          </div>

          {/* 2nd Row - Vehicle Name and Action Buttons */}
          <div className="flex flex-col sm:flex-row justify-between gap-0 w-full">
            {/* Left Section: Search Bar */}
            <div className="flex-shrink min-w-[100px] max-w-[300px] justify-end w-full sm:w-auto">
              <TextField
                variant="outlined"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search"
                sx={(theme) => ({
                  '& .MuiOutlinedInput-root': {
                    borderColor: theme.palette.action.selected,
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                  },
                  '& .MuiInputBase-root': {
                    padding: '0rem 1rem',
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '0px 12px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                  },
                })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={searchIcon} alt="icon" width={16} height={16} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={(theme) => ({
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        borderLeft: `1px solid ${theme.palette.action.selected}`,
                        paddingLeft: '8px',
                      })}
                    >
                      <img
                        src={filterIcon}
                        alt="filter"
                        width={24}
                        height={24}
                        onClick={() => setIsFilterModelOpen(true)}
                        style={{ cursor: 'pointer' }}
                      />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  style: {
                    fontSize: '14px',
                    fontWeight: 500,
                  },
                }}
              />
              {/* {matchStatus && (
                                <Box
                                    mt={1}
                                    px={2}
                                    py={1}
                                    sx={{
                                        backgroundColor: matchStatus === 'found' ? '#d4edda' : '#f8d7da',
                                        color: matchStatus === 'found' ? '#155724' : '#721c24',
                                        border: `1px solid ${matchStatus === 'found' ? '#c3e6cb' : '#f5c6cb'}`,
                                        borderRadius: '4px',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                    }}
                                >
                                    {matchStatus === 'found'
                                        ? 'Vehicle found!'
                                        : 'Vehicle not found. Please check the registration number.'}
                                </Box>
                            )} */}
              {/* your existing search bar code */}

              {matchStatus && (
                <Box
                  mt={0.5}
                  px={1.5}
                  py={0.5}
                  sx={{
                    backgroundColor: matchStatus === 'found' ? '#d4edda' : '#f8d7da',
                    color: matchStatus === 'found' ? '#155724' : '#721c24',
                    border: `1px solid ${matchStatus === 'found' ? '#c3e6cb' : '#f5c6cb'}`,
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 500,
                    maxWidth: 'fit-content',
                    transition: 'opacity 0.3s ease-in-out',
                  }}
                >
                  {matchStatus === 'found' ? 'Vehicle found' : 'Vehicle not found'}
                </Box>
              )}
            </div>

            {/* Right Section: Action Buttons */}
            <div className="flex flex-wrap gap-2 justify-end ml-auto">
              {/* <Button
                                onClick={handleDeleteClick}
                                variant="text"
                                color="error"
                                startIcon={<Delete />}
                                sx={{
                                    textTransform: 'none',
                                    '&:hover': { backgroundColor: 'rgba(244, 67, 54, 0.04)' },
                                }}
                            >
                                Delete
                            </Button> */}

              <Button
                variant="text"
                color="secondary"
                startIcon={<Videocam />}
                onClick={() => handleLiveFeedOpen(initialVehicleData?.vehicleRegistrationNo)}
                sx={{
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'rgba(156, 39, 176, 0.04)' },
                  color: 'blue',
                }}
              >
                Live Footage
              </Button>

              <Button
                variant="text"
                color="secondary"
                startIcon={<img src={backForward} width={24} height={24} />}
                onClick={() => handleRequestPlayBackOpen(initialVehicleData?.vehicleRegistrationNo)}
                sx={{
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'rgba(156, 39, 176, 0.04)' },
                  color: 'blue',
                }}
              >
                Request Video Playback
              </Button>

              <CustomIconButton
                icon={<MoreVertIcon />}
                text=""
                background="transparent"
                variant="outlined"
                onClick={handleMenuOpen}
              />
              <Menu anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={handleMenuClose}>
                {/* <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    navigate('/directories/vehicles/new', { state: initialVehicleData });
                  }}
                >.
                  < img src={editIcon} alt="edit" width={16} height={16} style={{ marginRight: '8px' }} />
                  Edit Vehicle
                </MenuItem> */}
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    handleShareLink();
                  }}
                >
                  <img src={share} alt="share" width={16} height={16} style={{ marginRight: '8px' }} />
                  Share Vehicle Details
                </MenuItem>
              </Menu>

              <CustomIconButton
                icon={<img src={download} alt="download" width={16} height={16} />}
                text="Download"
                background="transparent"
                variant="outlined"
                onClick={() => setIsDownloadModalOpen(true)}
              />

              <CustomIconButton
                text="Dashboard"
                variant="contained"
                onClick={() => navigate('/vehicles/dashboard', { state: initialVehicleData })}
              />
            </div>
          </div>
          <div className="bg-white rounded-2xl" style={{ width: '30%' }}>
            <p className="text-gray-500 text-sm">Created on: {initialVehicleData?.createdAt || 'NA'}</p>
          </div>

          <div className="bg-white rounded-2xl mb-2" style={{ width: '100%' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              {/* Tabs with 30% width (left side) */}
              <Tabs
                value={activeTab}
                onChange={(e, newVal) => setActiveTab(newVal)}
                sx={{
                  flexShrink: 0, // Prevent shrinking
                  borderRadius: '8px',
                  width: 'fit-content',
                  padding: '4px',
                  backgroundColor: theme.palette.selected,
                  '& .MuiTab-root': { color: 'black !important' },
                }}
                TabIndicatorProps={{ style: { display: 'none' } }}
              >
                <Tab
                  label="General Details"
                  value="generalDetails"
                  sx={{
                    ...(activeTab === 'generalDetails' && {
                      backgroundColor: theme.palette.background.default,
                      borderRadius: '8px',
                      fontWeight: 600,
                      padding: '8px 16px',
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }),
                  }}
                />
                <Tab
                  label="Trip History"
                  value="tripHistory"
                  sx={{
                    ...(activeTab === 'tripHistory' && {
                      backgroundColor: theme.palette.background.default,
                      borderRadius: '8px',
                      fontWeight: 600,
                      padding: '8px 16px',
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }),
                  }}
                />
                <Tab
                  label="Running History"
                  value="runningHistory"
                  sx={{
                    ...(activeTab === 'runningHistory' && {
                      backgroundColor: theme.palette.background.default,
                      borderRadius: '8px',
                      fontWeight: 600,
                      padding: '8px 16px',
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }),
                  }}
                />
              </Tabs>
              {activeTab == 'runningHistory' && (
                <div style={{ position: 'relative', zIndex: 100 }}>
                  {' '}
                  <DateRangeSelectorButton
                    defaultRange={defaultDateRange}
                    onDateRangeChange={handleDateRangeChange}
                    addTime={true}
                  />
                </div>
              )}
              {/* {activeTab === 'runningHistory' && historyDate && <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => handleRegenerateHistory(initialVehicleData?.vehicleRegistrationNo)}
                                sx={{
                                    height: '40px',
                                    whiteSpace: 'nowrap',
                                    textTransform: 'none',
                                    ml: 'auto' // Pushes button to the right
                                }}
                                startIcon={
                                    <img
                                        src={reset}
                                        alt="Reset"
                                        style={{
                                            width: 20,
                                            height: 20,
                                        }}
                                    />}
                            >
                                Regenerate History
                            </Button>} */}
            </Box>
          </div>
        </div>

        {/* Tab Content - Takes Full Width */}
        <div>
          {activeTab === 'generalDetails' && (
            <div className="flex flex-col lg:flex-row gap-6">
              {/* Left Section */}
              <div className="flex overflow-auto flex-1" style={{ height: 'calc(100vh - 25rem)' }}>
                <div className="flex flex-col overflow-auto gap-6 flex-1">
                  {/* Vehicle Identification */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-white">
                    <h3 className="text-lg font-semibold mb-4">Vehicle Identification</h3>
                    <p className="text-gray-600 mb-2">
                      Vehicle Registration: <b>{initialVehicleData?.vehicleRegistrationNo}</b>
                    </p>
                    <p className="text-gray-600">
                      Vehicle Name: <b>{initialVehicleData?.vehicleName}</b>
                    </p>
                  </div>

                  {/* Vehicle Details */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-white">
                    <h3 className="text-lg font-semibold mb-4">Vehicle Details</h3>
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-4 justify-between">
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Depot:</span>
                        <span className="text-gray-500">{initialVehicleData.groupName}</span>
                      </div>
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Device Type:</span>
                        <span className="text-gray-500">{initialVehicleData.deviceType}</span>
                      </div>
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Vehicle Product Type:</span>
                        <span className="text-gray-500">
                          {initialVehicleData.vehicleProductType ? initialVehicleData.vehicleProductType : 'NA'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Status and Ignition */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-white">
                    <div className="flex justify-between">
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Status</span>
                        <span
                          className={`px-2 py-1 text-white rounded ${
                            initialVehicleData.vehicleState === 'RUNNING'
                              ? 'bg-green-500'
                              : initialVehicleData.vehicleState === 'IDLE'
                              ? 'bg-yellow-500'
                              : 'bg-red-500'
                          }`}
                          style={{ width: 'fit-content' }}
                        >
                          {initialVehicleData.vehicleState}
                        </span>
                      </div>
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Ignition Status</span>
                        <span className="bg-blue-500 text-white px-2 py-1 rounded w-fit">
                          {initialVehicleData.vehicleState === 'RUNNING' ||
                          initialVehicleData.vehicleState === 'IDLE'
                            ? 'ON'
                            : 'OFF'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Activity Data */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-white">
                    <h3 className="text-lg font-semibold mb-4">Activity Data</h3>
                    <div className="flex flex-wrap justify-between gap-2">
                      {[
                        {
                          label: 'Last Data Received',
                          value: formatCustomTimestamp(initialVehicleData?.lastUpdateTime) || 'NA',
                        },
                        {
                          label: 'Distance Travelled Today',
                          value: `${initialVehicleData?.totalKmToday?.toFixed(2) || 0} km`,
                        },
                        { label: 'Coordinates String', value: address },
                        { label: 'Last Received Speed', value: `${initialVehicleData?.gpsSpeed} Km/h` },
                      ].map((item, i) => (
                        <div key={i} className="flex flex-col gap-1 flex-[0_0_48%]">
                          <span className="font-medium">{item.label}</span>
                          <span className="text-gray-500">{item.value}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Assignment Details */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-white">
                    <h3 className="text-lg font-semibold mb-4">Assignment Details</h3>
                    <p>
                      <span className="font-medium">Trip Name & ID:</span>{' '}
                      {`${initialVehicleData?.tripName || 'NA'} (${initialVehicleData?.tripId || 'NA'})`}
                    </p>
                  </div>

                  {/* Fuel Details */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-white">
                    <h3 className="text-lg font-semibold mb-4">Fuel Details</h3>
                    <div className="flex justify-between">
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Fuel Level:</span>
                        <span className="text-gray-500">{initialVehicleData?.fuelLevel || 'NA'}</span>
                      </div>
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Fuel Consumption Today:</span>
                        <span className="text-gray-500">{initialVehicleData?.fuelConsumption || 'NA'}</span>
                      </div>
                    </div>
                  </div>

                  {/* Driver Details */}
                  <div className="border border-gray-200 rounded-xl p-4 bg-white">
                    <h3 className="text-lg font-semibold mb-4">Driver Details</h3>
                    <div className="flex justify-between">
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Employee Id:</span>
                        <span className="text-gray-500">NA</span>
                      </div>
                      <div className="flex flex-1 flex-col gap-1">
                        <span className="font-medium">Driver Name:</span>
                        <span className="text-gray-500">{initialVehicleData?.driverName}</span>
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 mt-2">
                      <span className="font-medium">Driver Contact:</span>
                      <span className="text-gray-500">{initialVehicleData?.driverContact || 'NA'}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - Map */}
              <div
                className="bg-white rounded-2xl shadow-md overflow-hidden flex flex-col h-full flex-1"
                style={{ height: 'calc(100vh - 24rem)' }}
              >
                <div className="flex-1 relative">
                  <MapPreview mapData={[initialVehicleData]} zoomRatio={7} />
                </div>
              </div>
            </div>
          )}

          {activeTab === 'tripHistory' && (
            <div className="w-full">
              <TripHistoryTable vehicleRegistrationNumber={initialVehicleData.vehicleRegistrationNo} />
            </div>
          )}

          {activeTab === 'runningHistory' && showHistory && initialVehicleData && (
            <div className="w-full">
              <TripSummary
                vehicleRegistrationNumber={initialVehicleData?.vehicleRegistrationNo}
                historyDate={historyDate}
                vehicleData={initialVehicleData}
              />
            </div>
          )}
        </div>
      </div>

      <PlaybackPlayerModal
        open={vehicleVideoPlayer}
        onClose={handleVideoPlayerClose}
        requestData={
          Object.keys(footageVideoData?.data || {}).length > 0 ? footageVideoData?.data : requestData || {}
        }
        cameraId={cameraData?.data[requestData?.cameraType]}
        deviceId={initialVehicleData?.deviceId || ''}
        onRefresh={handleVideoPlayerRefresh}
        verhicleId={initialVehicleData?.vehicleRegistrationNo}
      />
      <RequestedVideoModal
        open={isRequestPlayBack.isOpen}
        handleRequested={handleRequested}
        onClose={handleRequestedModalClose}
        title="Request Video Playback"
        cameraArr={cameraArr}
        description="Select a vehicle and specify the date and time range to retrieve the required video footage."
      />

      <ShareLinkModalBox
        open={isShareLikOpen}
        onClose={handelShareLinkModalClose}
        heading="Share Vehicle Details"
        subheading="Select Date & Time to generate shareable link"
        shareLink={shareLink}
        vehicleId={initialVehicleData?.vehicleRegistrationNo}
      />
      <RequestVehicleHistoryModal
        open={isRequestHistory.isOpen}
        handleRequested={handleHistoryRequested}
        onClose={handleRequestedHistoryModalClose}
        title="Vehicle Running History"
        description="To retrieve vehicle running history."
      />
      <Dialog
        open={isDeleteModalOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Delete Vehicle</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this vehicle?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <LiveFeedModal
        trip={{
          vehicleRegNo: initialVehicleData?.vehicleRegistrationNo,
          vehicleId: initialVehicleData?.vehicleRegistrationNo,
        }}
        vehicleId={initialVehicleData?.deviceId}
        open={isLiveFeedOpen.isOpen}
        onClose={handleLiveFeedClose}
        isDash={true}
        deviceType={initialVehicleData?.deviceType}
      />
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any}
      />
      <Dialog
        open={isDownloadModalOpen}
        onClose={handleDownloadModalClose}
        aria-labelledby="download-modal-title"
      >
        <DialogTitle id="download-modal-title">
          <Typography variant="h6" fontWeight={600}>
            Download Vehicles Data
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>Please select a file format for your download.</DialogContentText>
          <FormControl component="fieldset" sx={{ mt: 2 }}>
            <Typography variant="body1" fontWeight={500} gutterBottom>
              Format
            </Typography>
            <RadioGroup
              aria-label="format"
              name="format"
              value={selectedFormat}
              onChange={handleFormatChange}
              row
            >
              <FormControlLabel value="excel" control={<Radio />} label="Excel" />
              <FormControlLabel value="csv" control={<Radio />} label="CSV" />
              <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDownloadModalClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDownload} color="primary" variant="contained">
            Download
          </Button>
        </DialogActions>
      </Dialog>
      <FilterDataModel
        open={isFilterModel}
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        title="Filter"
        description="Use the options below to refine your search and find specific trips quickly."
        showTripStatus={false}
        showClearButton={false}
        showGroupFilter={false}
        trgtcData={true}
      />
    </>
  );
};

export default VehicleDetails;
